import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

const getLegendItems = (isAdmin) => {
  const prefix = isAdmin ? "admin-" : "";
  const itemClass = isAdmin ? "admin-legend-item" : "legend-item";
  const dotClass = isAdmin ? "admin-legend-dot" : "legend-dot";

  return [
    {
      id: "available",
      label: "Disponible",
      itemClass,
      dotClass: `${dotClass} ${prefix}available`,
    },
    isAdmin && {
      id: "unavailable",
      label: "Indisponible",
      itemClass,
      dotClass: `${dotClass} ${prefix}unavailable`,
    },
    {
      id: "booked",
      label: "Réservé",
      itemClass,
      dotClass: `${dotClass} ${prefix}booked`,
    },
  ].filter(Boolean);
};

const CalendarLegend = ({ isAdmin = false }) => {
  const legendItems = getLegendItems(isAdmin);

  return (
    <div className="calendar-legend">
      {legendItems.map((item) => (
        <div key={item.id} className={item.itemClass}>
          <span className={item.dotClass}></span>
          <Typography variant="body2">{item.label}</Typography>
        </div>
      ))}
    </div>
  );
};

CalendarLegend.propTypes = {
  isAdmin: PropTypes.bool,
};

export default CalendarLegend;
